exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-detail[data-v-4ecb814e]:after{content:\"\";display:block;clear:both}.detail-w[data-v-4ecb814e]{width:var(--portalContainerWidth)}.detail-w .ql-editor[data-v-4ecb814e]{padding:12px 0}.hyperlink-color[data-v-4ecb814e]{color:#3b9bf0}[data-v-4ecb814e] .ql-container.ql-snow{border:none}[data-v-4ecb814e] .ql-align-center img{display:inline-block}.detail-info[data-v-4ecb814e]{font-family:Microsoft YaHei}", ""]);

// exports
